import React from 'react';

const IconDribbble= () => (
	<svg fill="#FFFFFF" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg"
	width="800px" height="800px" viewBox="10 10 74 74">  {/* Adjusted viewBox for scaling */}
 <g>
   <g>
	 <path d="M44.918,36.206c-5.232-9.257-10.824-17.06-11.95-18.608c-8.996,4.292-15.731,12.574-17.893,22.54c0.091,0,0.196,0,0.319,0
			 C18.403,40.138,30.874,39.896,44.918,36.206z"/>
	 <path d="M52.673,52.63C34.78,58.855,28.008,71.053,27.074,72.882c5.521,4.254,12.43,6.792,19.926,6.792
			 c4.471,0,8.732-0.904,12.617-2.535c-0.521-3.037-2.426-12.84-6.907-24.521C52.697,52.621,52.686,52.626,52.673,52.63z"/>
	 <path d="M68.521,22.532C62.77,17.49,55.236,14.429,47,14.429c-2.534,0-4.999,0.292-7.367,0.842
			 c1.328,1.794,6.917,9.515,12.018,18.844C62.672,29.945,67.611,23.776,68.521,22.532z"/>
	 <path d="M49.236,47.15c0.359-0.114,0.723-0.223,1.087-0.326c-0.777-1.745-1.617-3.492-2.497-5.215
			 c-14.5,4.305-28.572,4.642-32.623,4.642c-0.375,0-0.661-0.003-0.856-0.007c-0.008,0.269-0.015,0.537-0.015,0.806
			 c0.001,8.285,3.111,15.854,8.224,21.614C23.936,66.385,32.912,52.426,49.236,47.15z"/>
	 <path d="M59.238,51.016c4.062,11.205,5.824,20.394,6.262,22.906c7.152-4.928,12.249-12.626,13.725-21.527
			 c-1.242-0.379-6.582-1.873-13.408-1.871C63.736,50.521,61.52,50.662,59.238,51.016z"/>
	 <path d="M54.352,39.337c0.732,1.506,1.438,3.036,2.094,4.578c0.224,0.521,0.439,1.041,0.652,1.559
			 c2.529-0.311,5.051-0.433,7.447-0.433c7.428,0,13.646,1.163,15.112,1.46c-0.125-7.518-2.808-14.424-7.218-19.889
			 C71.299,28.091,65.781,34.627,54.352,39.337z"/>
   </g>
 </g>
</svg>
);

export default IconDribbble;



